import DownloadIcon from '@mui/icons-material/Download'
import InfoOutlineIcon from '@mui/icons-material/InfoOutline'
import { Button, Drawer, Stack, Typography } from '@mui/material'
import { FC } from 'react'
import { CSVLink } from 'react-csv'
import { Header } from 'src/components/header/Header'
import { HeaderTitle } from 'src/components/header/HeaderTitle'
import { gray } from 'src/features/muikds/kdsColors'
import { sanitizeFilename } from '../../../utils/sanitizeFilename'
import { useMasterDeleteRecords } from './hooks/useMasterDeleteRecords'

const csvDataForDelete = [['製品管理番号']]

type Props = Readonly<{
  masterUuid: string
  masterName: string
  open: boolean
  closeDrawer: () => void
}>

export const MasterRecordsDeleteDrawer: FC<Props> = ({
  masterUuid,
  masterName,
  open,
  closeDrawer,
}) => {
  const {
    handleDrawerClose,
    CsvFileUploadSectionEl,
    ConfirmDialogEl,
    UploadButtonEl,
    CloseButtonEl,
  } = useMasterDeleteRecords({ masterUuid, closeDrawer })

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={handleDrawerClose}
      sx={{ '& .MuiDrawer-paper': { width: '600px' } }}
    >
      <Header>
        <HeaderTitle title="CSVで削除" />
      </Header>
      <Stack sx={{ height: '100%' }}>
        <Stack sx={{ flex: 1 }}>
          <Stack spacing={2} sx={{ padding: 3 }}>
            <Stack
              spacing={1}
              sx={theme => ({
                border: `1px solid ${theme.palette.error.main}`,
                borderRadius: 1,
                padding: 2,
              })}
            >
              <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                <InfoOutlineIcon color="error" fontSize="small" />
                <Typography variant="subtitle1">削除の手順</Typography>
              </Stack>
              <Stack spacing={2} sx={{ paddingLeft: '34px' }}>
                <Stack spacing={1}>
                  <Typography>
                    1. 削除用CSVデータをダウンロードします
                  </Typography>
                  <Stack direction="row" spacing={1}>
                    <CSVLink
                      data={csvDataForDelete}
                      uFEFF={true}
                      filename={`${sanitizeFilename(masterName)}_削除用.csv`}
                    >
                      <Button
                        size="medium"
                        variant="outlined"
                        startIcon={<DownloadIcon />}
                      >
                        削除用CSVデータ
                      </Button>
                    </CSVLink>
                  </Stack>
                </Stack>
                <Stack spacing={1}>
                  <Typography>
                    2.
                    ダウンロードしたCSVファイルを開き、削除したい製品管理番号を入力してください
                  </Typography>
                </Stack>
                <Stack spacing={1}>
                  <Typography>
                    3. CSVファイルを保存し、下記よりアップロードしてください
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
            {CsvFileUploadSectionEl}
          </Stack>
        </Stack>
        <Stack
          direction="row"
          spacing={2}
          justifyContent="flex-end"
          sx={{
            padding: 3,
            borderTop: 1,
            borderColor: 'divider',
            backgroundColor: gray[2],
          }}
        >
          {CloseButtonEl}
          {UploadButtonEl}
        </Stack>
      </Stack>
      {ConfirmDialogEl}
    </Drawer>
  )
}
